import { WAITING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID } from '../../constants';
import {
  VisitorSettingsDrawerControlMenuItemWrapper as BaseVisitorSettingsDrawerControlMenuItem,
  VisitorSettingsDrawerButton,
} from '../../controls/VisitorSettingsDrawerControlsWrapper';

export function VisitorWaitingSettingsControlButton() {
  return <VisitorSettingsDrawerButton drawerId={WAITING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID} />;
}

export function VisitorWaitingSettingsDrawerControlMenuItem() {
  return <BaseVisitorSettingsDrawerControlMenuItem drawerId={WAITING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID} />;
}
